/** Atualiza a query da URL sem recarregar. `resetPage` volta para a página 1 quando o filtro muda. */
export function patchSearchParams(setSearchParams, updates, { resetPage = true } = {}) {
    setSearchParams(
        prev => {
            const next = new URLSearchParams(prev);
            Object.entries(updates).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') next.delete(key);
                else next.set(key, String(value));
            });
            if (resetPage) next.set('page', '1');
            return next;
        },
        { replace: true },
    );
}

export function formatDatePart(item) {
    if (!item) return null;
    if (typeof item === 'string') {
        const trimmed = item.trim();
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) return trimmed;
        const parsed = new Date(trimmed);
        if (!Number.isNaN(parsed.getTime()) && !/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
            const day = String(parsed.getDate()).padStart(2, '0');
            const month = String(parsed.getMonth() + 1).padStart(2, '0');
            return `${day}/${month}/${parsed.getFullYear()}`;
        }
        return null;
    }
    if (typeof item?.format === 'function') return item.format('DD/MM/YYYY');
    const date = item instanceof Date ? item : new Date(item);
    if (Number.isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${date.getFullYear()}`;
}

/** DatePicker range / string da URL → ['DD/MM/YYYY', ...]. */
export function serializeDateRange(range) {
    if (!range) return [];
    if (typeof range === 'string') {
        return range
            .split(/\s+a\s+|[,;]/)
            .map(part => formatDatePart(part))
            .filter(Boolean);
    }
    if (!Array.isArray(range)) {
        const single = formatDatePart(range);
        return single ? [single] : [];
    }
    return range.map(formatDatePart).filter(Boolean);
}

export function dateRangeLabel(range) {
    return serializeDateRange(range).join(' a ');
}

export function dateRangeFromParams(from, to) {
    const start = formatDatePart(from);
    const end = formatDatePart(to);
    if (start && end) return [start, end];
    if (start) return [start];
    return [];
}
